// Coordinates the full-screen prompt scrims (feature announcements + install
// coach) so their dark backdrops never stack on top of each other. Each prompt
// that renders a scrim registers via pushPromptOverlay() while it's on screen.
// The deferring nudges — FeatureAnnouncementBanner and the dashboard / marketing
// announcement triggers — call hasActivePromptOverlay() and stay hidden while
// any scrim is active, re-checking on PROMPT_OVERLAY_EVENT. The install coach
// only registers (it does not consult the count), so it surfaces over those
// lower-priority nudges rather than deferring to them.

let activeCount = 0;

export const PROMPT_OVERLAY_EVENT = "prompt-overlay-change";

function emitChange(): void {
  window.dispatchEvent(new Event(PROMPT_OVERLAY_EVENT));
}

/**
 * Register an active prompt scrim. Returns a release function (idempotent) —
 * call it on unmount / when the scrim hides. Designed to be returned directly
 * from a `useEffect`.
 */
export function pushPromptOverlay(): () => void {
  activeCount += 1;
  emitChange();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    activeCount = Math.max(0, activeCount - 1);
    emitChange();
  };
}

export function hasActivePromptOverlay(): boolean {
  return activeCount > 0;
}
